import { useState } from 'react';
import { FormField as FormFieldType, FormFieldGroup as FormFieldGroupType } from '../../Types/forms';
import FormField from './FormField';
import './FormFieldGroup.scss';

type FormFieldGroupProps = {
	group: FormFieldGroupType;
	fields: FormFieldType[];
};

const FormFieldGroup = ({ group, fields }: FormFieldGroupProps) => {
	const isExpandable = group.settings.expandable ?? false;
	const [expanded, setExpanded] = useState(isExpandable ? (group.settings.startExpanded ?? true) : true);

	const style: React.CSSProperties = {};
	if (group.settings.borderWidth) style.borderWidth = group.settings.borderWidth;
	if (group.settings.borderColor) style.borderColor = group.settings.borderColor;
	if (group.settings.backgroundColor) style.backgroundColor = group.settings.backgroundColor;
	if (group.settings.textColor) style.color = group.settings.textColor;

	const headerStyle: React.CSSProperties = {};
	if (group.settings.headerBackgroundColor) headerStyle.backgroundColor = group.settings.headerBackgroundColor;
	if (group.settings.headerTextColor) headerStyle.color = group.settings.headerTextColor;

	const classNames = ['biz-form-field-group'];
	if (isExpandable) classNames.push('biz-form-field-group--expandable');
	if (expanded) classNames.push('biz-form-field-group--expanded');

	return (
		<div className={classNames.join(' ')} style={style}>
			{(group.name || isExpandable) && (
				<div
					className='biz-form-field-group__header'
					style={headerStyle}
					onClick={isExpandable ? () => setExpanded(!expanded) : undefined}
				>
					{group.settings.imageUrl && (
						<img className='biz-form-field-group__image' src={group.settings.imageUrl} alt='' />
					)}
					{group.name && <h4 className='biz-form-field-group__name'>{group.name}</h4>}
					{isExpandable && (
						<i className={`far ${expanded ? 'fa-chevron-up' : 'fa-chevron-down'} biz-form-field-group__toggle`} />
					)}
				</div>
			)}
			{expanded && (
				<div className='biz-form-field-group__fields'>
					{fields.map((field) => (
						<FormField key={field.key} field={field} />
					))}
				</div>
			)}
		</div>
	);
};

export default FormFieldGroup;
